<div class="careers__hero-wrapper">
  <app-hero [config]="heroConfig"></app-hero>
  <app-navbar></app-navbar>
</div>
<app-job-offers></app-job-offers>
<app-why></app-why>
<app-perks-and-benefits></app-perks-and-benefits>
<app-recruitment></app-recruitment>
<app-contact-form [config]="HR_CONFIG"></app-contact-form>
